<script>
  export let color;
  export let size;
  export let opacity;
  export let style = '';
</script>

<style>
  .km-bubble {
    border-radius: 50% !important;
    border-width: 1px;
    border-style: solid;
    overflow: hidden;
  }

  .km-bubble div {
    height: 100%;
    width: 100%;
  }
</style>

<div
  class="km-bubble"
  style="border-color: {color}; width: {size}px; height: {size}px; {style}">
  <div style="background-color: {color}; opacity: {opacity}" />
</div>
